module.exports = __webpack_public_path__ + "app/img/logo_per.3cfbf6db.png";